import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import {
  ApiResponse,
  CreateMobileApplicationRequest,
  MobileApplication,
  UpdateMobileApplicationRequest,
} from '@vision/ui/interfaces';
import { createHttpExtraOptions } from '@vision/ui/utils';
import { axiosBaseQuery } from './base.service';

export const MobileApplicationsService = createApi({
  reducerPath: 'MobileApplicationsService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['MobileApplications'],
  endpoints: (builder) => ({
    getMobileApplications: builder.query<MobileApplication[], void>({
      query: () => ({
        url: '/v1/mobile_applications',
        method: HttpMethod.GET,
      }),
      providesTags: ['MobileApplications'],
    }),
    createMobileApplication: builder.mutation<ApiResponse<MobileApplication>, CreateMobileApplicationRequest>({
      query: (data) => ({
        url: '/v1/mobile_applications',
        method: HttpMethod.POST,
        data,
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.mobileApplication.createMobileApplication.{{status}}',
          },
        }),
      }),
      invalidatesTags: ['MobileApplications'],
    }),
    updateMobileApplication: builder.mutation<
      ApiResponse<MobileApplication>,
      { id: string; data: UpdateMobileApplicationRequest }
    >({
      query: ({ id, data }) => ({
        url: `/v1/mobile_applications/${id}/update`,
        method: HttpMethod.POST,
        data,
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.mobileApplication.updateMobileApplication.{{status}}',
          },
        }),
      }),
      invalidatesTags: ['MobileApplications'],
    }),
    deleteMobileApplication: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/v1/mobile_applications/${id}/destroy`,
        method: HttpMethod.POST,
        extraOptions: createHttpExtraOptions({
          notification: {
            translationMessageKey: 'http.message.mobileApplication.deleteMobileApplication.{{status}}',
          },
        }),
      }),
      invalidatesTags: ['MobileApplications'],
    }),
  }),
});

export const {
  useGetMobileApplicationsQuery,
  useCreateMobileApplicationMutation,
  useUpdateMobileApplicationMutation,
  useDeleteMobileApplicationMutation,
} = MobileApplicationsService;
